import type { ReadOnlyGridData } from './ReadOnlyGrid';

export const emptyGrid: ReadOnlyGridData = {
  columns: [],
  cells: [],
};

export function formatGridToClipboard(grid: ReadOnlyGridData | undefined): string[][] {
  if (grid === undefined) {
    return [];
  }
  const headers = grid.columns.map(c => c.alias ?? c.name);
  const table = grid.cells.map(row => {
    const cells = grid.columns.map(c => {
      const cellValue = row[c.name];
      return cellValue !== undefined ? cellValue.toString() : '_';
    });
    return cells;
  });
  return [headers].concat(table);
}
